var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useRef, useEffect } from 'react';
import ItemList from './ItemList';
import Book from './Book';
import Navigation from '@components/App/Navigation';
import TagTree, { UNTAGGED } from '@components/App/TagTree';
import { CloudUploadIcon, SearchIcon } from '@heroicons/react/solid';
import { api } from '../../api/client';
import log from '@components/App/log';
export var Library = function () {
    var _a = useState([]), items = _a[0], setItems = _a[1];
    var _b = useState(''), currentBook = _b[0], setCurrentBook = _b[1];
    var _c = useState(undefined), currentBookType = _c[0], setCurrentBookType = _c[1];
    var _d = useState(''), currentBookTitle = _d[0], setCurrentBookTitle = _d[1];
    var _e = useState(null), selectedTag = _e[0], setSelectedTag = _e[1];
    var _f = useState(new Set()), selectedIds = _f[0], setSelectedIds = _f[1];
    var _g = useState(''), search = _g[0], setSearch = _g[1];
    var _h = useState(''), newProjectName = _h[0], setNewProjectName = _h[1];
    var dropArea = useRef();
    var loadItems = function () {
        api
            .listItems()
            .then(setItems)
            .catch(function (e) { return log(e.message); });
    };
    useEffect(function () {
        loadItems();
    }, []);
    var viewItem = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var blob;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    log('View item: ' + item.title);
                    return [4 /*yield*/, api.fetchFileBlob(item.id)];
                case 1:
                    blob = _a.sent();
                    setCurrentBookType(item.file_type === 'epub' ? 'epub' : 'pdf');
                    setCurrentBookTitle(item.title);
                    setCurrentBook(URL.createObjectURL(blob));
                    return [2 /*return*/];
            }
        });
    }); };
    var closeBook = function () {
        if (currentBook)
            URL.revokeObjectURL(currentBook);
        setCurrentBook('');
        setCurrentBookType(undefined);
        setCurrentBookTitle('');
    };
    var downloadBook = function (url) {
        window.open(url, '_blank');
    };
    var uploadFile = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var title, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    title = file.name.replace(/\.[^/.]+$/, '');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api.createItem({ title: title }, file)];
                case 2:
                    _a.sent();
                    loadItems();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    log('upload failed: ' + e_1.message);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var uploadFiles = function (e) {
        var _a, _b;
        Array.from((_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.files) !== null && _b !== void 0 ? _b : []).forEach(uploadFile);
    };
    var highlight = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    var unhighlight = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    var handleDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();
        // Item rows being dragged onto the tag tree set this - ignore that case
        // here so dropping a row back onto the page doesn't try to re-upload it.
        if (e.dataTransfer.types.includes('text/rigormining-item-id'))
            return;
        Array.from(e.dataTransfer.files).forEach(uploadFile);
    };
    useEffect(function () {
        var listeners = new Map();
        if (dropArea === null || dropArea === void 0 ? void 0 : dropArea.current) {
            ['dragenter', 'dragover'].forEach(function (eventName) {
                dropArea.current.addEventListener(eventName, highlight, false);
                listeners.set(eventName, highlight);
            });
            ['dragleave'].forEach(function (eventName) {
                dropArea.current.addEventListener(eventName, unhighlight, false);
                listeners.set(eventName, unhighlight);
            });
            ['drop'].forEach(function (eventName) {
                dropArea.current.addEventListener(eventName, handleDrop, false);
                listeners.set(eventName, handleDrop);
            });
            return function () {
                listeners.forEach(function (l, s) {
                    var _a;
                    (_a = dropArea === null || dropArea === void 0 ? void 0 : dropArea.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(s, l);
                });
            };
        }
    });
    var toggleSelected = function (id) {
        setSelectedIds(function (prev) {
            var next = new Set(prev);
            if (next.has(id))
                next.delete(id);
            else
                next.add(id);
            return next;
        });
    };
    var addTagToItem = function (itemId, tagName) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.addTag(itemId, tagName)];
                case 1:
                    _a.sent();
                    loadItems();
                    return [2 /*return*/];
            }
        });
    }); };
    var renameTag = function (from, to) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.renameTag(from, to)];
                case 1:
                    _a.sent();
                    if (selectedTag === from)
                        setSelectedTag(to);
                    loadItems();
                    return [2 /*return*/];
            }
        });
    }); };
    var addSelectedToProject = function () { return __awaiter(void 0, void 0, void 0, function () {
        var name;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    name = newProjectName.trim();
                    if (!name || selectedIds.size === 0)
                        return [2 /*return*/];
                    return [4 /*yield*/, Promise.all(Array.from(selectedIds).map(function (id) { return api.addTag(id, name); }))];
                case 1:
                    _a.sent();
                    setNewProjectName('');
                    setSelectedIds(new Set());
                    loadItems();
                    return [2 /*return*/];
            }
        });
    }); };
    var onNewProjectKeyDown = function (e) {
        if (e.key === 'Enter')
            addSelectedToProject();
    };
    var allTagNames = Array.from(new Set(items.flatMap(function (i) { return i.tags.map(function (t) { return t.name; }); }))).sort();
    var visibleItems = items
        .filter(function (item) {
        if (selectedTag === null)
            return true;
        if (selectedTag === UNTAGGED)
            return item.tags.length === 0;
        return item.tags.some(function (t) { return t.name === selectedTag; });
    })
        .filter(function (item) {
        var _a;
        if (!search.trim())
            return true;
        var q = search.trim().toLowerCase();
        return item.title.toLowerCase().includes(q) || ((_a = item.authors) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(q);
    });
    return (React.createElement(React.Fragment, null,
        currentBook.length <= 0 && (React.createElement(React.Fragment, null,
            React.createElement(Navigation, { loggedIn: true }),
            React.createElement("div", { className: "flex", style: { height: 'calc(100vh - 4rem)' } },
                React.createElement(TagTree, { items: items, selected: selectedTag, onSelect: setSelectedTag, onDropItem: addTagToItem, onRenameTag: renameTag }),
                React.createElement("div", { ref: dropArea, className: "flex-1 overflow-y-auto" },
                    React.createElement("div", { className: "max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6" },
                        React.createElement("label", { htmlFor: "fileElem", className: "flex items-center gap-2 text-sm text-gray-500 border border-dashed border-gray-300 rounded-md px-3 py-2 mb-4 cursor-pointer hover:border-indigo-400 hover:text-indigo-600" },
                            React.createElement(CloudUploadIcon, { className: "h-4 w-4 flex-shrink-0", "aria-hidden": "true" }),
                            "Drop a PDF or EPUB here, or click to browse",
                            React.createElement("input", { type: "file", id: "fileElem", multiple: true, onChange: uploadFiles, className: "hidden", accept: ".pdf,.epub,application/pdf,application/epub,application/epub+zip,application/x-pdf" })),
                        React.createElement("div", { className: "flex items-center gap-3 mb-3" },
                            React.createElement("div", { className: "relative flex-1 max-w-xs" },
                                React.createElement(SearchIcon, { className: "h-4 w-4 text-gray-400 absolute left-2.5 top-2.5", "aria-hidden": "true" }),
                                React.createElement("input", { value: search, onChange: function (e) { return setSearch(e.target.value); }, placeholder: "Search title or author", className: "w-full pl-8 pr-3 py-1.5 text-sm border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500" })),
                            selectedTag !== null && selectedTag !== UNTAGGED && (React.createElement("a", { href: api.tagBibtexUrl(selectedTag), className: "ml-auto px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 whitespace-nowrap", title: "Download every item tagged \"" + selectedTag + "\" as one .bib file" }, "Export to BibTeX")),
                            selectedIds.size > 0 && (React.createElement("div", { className: "flex items-center gap-2 " + (selectedTag !== null && selectedTag !== UNTAGGED ? '' : 'ml-auto') },
                                React.createElement("span", { className: "text-xs text-gray-500" },
                                    selectedIds.size,
                                    " selected"),
                                React.createElement("input", { list: "rigormining-project-names", value: newProjectName, onChange: function (e) { return setNewProjectName(e.target.value); }, onKeyDown: onNewProjectKeyDown, placeholder: "Add to project...", className: "text-sm border border-gray-300 rounded-md shadow-sm px-2 py-1.5 focus:ring-indigo-500 focus:border-indigo-500" }),
                                React.createElement("datalist", { id: "rigormining-project-names" }, allTagNames.map(function (t) { return (React.createElement("option", { key: t, value: t })); })),
                                React.createElement("button", { onClick: addSelectedToProject, disabled: !newProjectName.trim(), className: "px-3 py-1.5 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50" }, "Add")))),
                        React.createElement(ItemList, { items: visibleItems, viewItem: viewItem, selectedIds: selectedIds, onToggleSelected: toggleSelected })))))),
        currentBook.length > 0 && (React.createElement(Book, { type: currentBookType, url: currentBook, title: currentBookTitle, closeBook: closeBook, downloadBook: downloadBook }))));
};
export default Library;
